export const selectJira = (state) => state.jira;

export const selectProjectList = (state) => selectJira(state).jiraProjectList;
